import { Suspense } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { TopBar } from './TopBar'
import { getVisibleNavItems } from './nav-items'
import { HeaderActionProvider } from './HeaderAction'
import { PageLoader } from '@/components/PageLoader'
import { PasskeyNudge } from '@/components/PasskeyNudge'
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { usePrefetchGeosites } from '@/hooks/useGeosites'
import { useAuth } from '@/auth/useAuth'

export function AppLayout() {
  const { isAdmin } = useAuth()
  useKeyboardShortcuts(isAdmin)
  usePrefetchGeosites()
  const location = useLocation()
  const navItems = getVisibleNavItems(isAdmin)
  return (
    <HeaderActionProvider>
      <div className="app-root">
        <TopBar />
        {/* Suspense-boundary — СНАРУЖИ keyed-div и стабилен между навигациями. React
           Router 7.18 оборачивает переходы в startTransition; если пересоздавать
           boundary через key на каждой навигации, переход с lazy-роутом подвисает
           (URL меняется, контент — нет). key на внутреннем div лишь перезапускает
           CSS-анимацию входа. */}
        <Suspense fallback={<PageLoader />}>
          <div key={location.pathname} className="route-content">
            <Outlet />
          </div>
        </Suspense>
        <PasskeyNudge />
        <nav className="bottom-nav" aria-label="Мобильная навигация">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `bottom-nav__link${isActive ? ' is-active' : ''}`}
              aria-label={item.label}
              title={item.label}
            >
              <span className="bottom-nav__icon" aria-hidden>
                {item.icon}
              </span>
            </NavLink>
          ))}
        </nav>
      </div>
    </HeaderActionProvider>
  )
}
